module.exports = __webpack_public_path__ + "img/item6.9407b046.png";